import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../modules';
import { setMenuID } from '../../../modules/tabMenu';
import SimilarImage from '../../../components/search/tabSimilarImage';
import { GetSimilarImageParamType } from '../../../lib/tabSimilarImage/type';
import {
  getSimilarImageAsync,
  setSimilarImageDataNull,
} from '../../../modules/tabSimilarImage';

function SimilarImageContainer() {
  const { loading, similar_image_data } = useSelector(
    (state: RootState) => state.tabSimilarImage
  );
  const dispatch = useDispatch();

  const onSetMenuID = (selectedMenuId: number) => {
    dispatch(setMenuID(selectedMenuId));
  };

  const onGetSimilarImage = (info: GetSimilarImageParamType) => {
    dispatch(getSimilarImageAsync.request(info));
  };

  const onSetSimilarImageDataNull = () => {
    dispatch(setSimilarImageDataNull());
  };

  return (
    <SimilarImage
      onSetSimilarImageDataNull={onSetSimilarImageDataNull}
      onGetSimilarImage={onGetSimilarImage}
      loading={loading}
      similar_image_data={similar_image_data}
    />
  );
}

export default SimilarImageContainer;
